import { render, staticRenderFns } from "./DeliverySection.vue?vue&type=template&id=05fc607f&scoped=true&"
import script from "./DeliverySection.vue?vue&type=script&lang=js&"
export * from "./DeliverySection.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySection.vue?vue&type=style&index=0&id=05fc607f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc607f",
  null
  
)

export default component.exports